export default __webpack_public_path__ + "static/media/Emergency_Contact_Icon.1caf33a8.svg";